import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector } from 'hooks/reduxHooks'

function getPhoneHref(phoneNumber: string) {
  return `tel:${phoneNumber.replace(/\s/g, '')}`
}

function getEmailHref(email: string) {
  return `mailto:${email}`
}

function useInfiniteConciergeDetails() {
  const intl = useIntl()
  const customerServiceRep = useAppSelector(state => state.loyalty.account.data?.customerServiceRep)

  return useMemo(() => {
    const fallbackPhoneNumber = intl.formatMessage({
      id: 'NrcvI35CxD0jru5XmLdu',
      defaultMessage: '+61 400 000 000',
      description: 'Placeholder Infinite concierge phone number in concierge details surfaces',
    })
    const fallbackEmail = intl.formatMessage({
      id: 'DdG5gW7W9667mBWpaGrd',
      defaultMessage: 'christian.surname@luxuryescapes.com',
      description: 'Placeholder Infinite concierge email address in concierge details surfaces',
    })
    const fallbackName = intl.formatMessage({
      id: 'tsASkkS_jhprov90PSfP',
      defaultMessage: 'Christian Surname',
      description: 'Placeholder Infinite concierge name in account drawer',
    })
    const phoneNumber = customerServiceRep?.phone ?? fallbackPhoneNumber
    const phoneDialNumber = phoneNumber.replace(/\s/g, '')
    const email = customerServiceRep?.email ?? fallbackEmail

    return {
      name: customerServiceRep ? `${customerServiceRep.firstName} ${customerServiceRep.lastName}` : fallbackName,
      title: intl.formatMessage({
        id: '4ZafDD1T0XtrNw7-MVr1',
        defaultMessage: 'Your Dedicated Concierge',
        description: 'Title shown for Infinite members dedicated concierge support in navigation contact menus',
      }),
      phoneNumber,
      phoneDialNumber,
      phoneHref: getPhoneHref(phoneDialNumber),
      email,
      emailHref: getEmailHref(email),
    }
  }, [customerServiceRep, intl])
}

export default useInfiniteConciergeDetails
